import React, { FC } from "react";
import { Box, Divider, IconButton, Modal } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { CloseButton, COLORS, EsgPrimaryLabel, PrimaryLabel } from "components";
import dayjs from "dayjs";

import { ApprovalsActions } from "./approvals-actions";
import { DETAIL_MODAL_COLUMNS } from "../columns";
import { ApprovalsDetailModalProps } from "./types";

export const ApprovalsDetailModal: FC<ApprovalsDetailModalProps> = ({ open, setOpen, detailData, actionId }) => (
  <Box>
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{
        position: "absolute" as "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "80%",
        height: "80%",
        bgcolor: "background.paper",
        boxShadow: 24,
        zIndex: 999,
        outline: "none",
      }}>
        <Box style={{ display: "flex", justifyContent: "space-between", cursor: "pointer", padding: "12px", alignItems: "center" }}>
          <Box sx={{ mx: 3, mt: 2, display: "flex", gap: 5 }}>
            <Box sx={{ gap: 1, display: "flex" }}>
              <PrimaryLabel>Action</PrimaryLabel>
              <EsgPrimaryLabel sx={{ color: "black" }}><ApprovalsActions value={detailData?.action} id={actionId?.toString()} /></EsgPrimaryLabel>
            </Box>
            <Box sx={{ gap: 1, display: "flex" }}>
              <PrimaryLabel>Name</PrimaryLabel>
              <EsgPrimaryLabel sx={{ color: "black" }}>{detailData?.user}</EsgPrimaryLabel>
            </Box>
            <Box sx={{ gap: 1, display: "flex" }}>
              <PrimaryLabel>Time Stamp</PrimaryLabel>
              <EsgPrimaryLabel sx={{ color: "black" }}>{dayjs(detailData?.createDate).format("MM/DD/YYYY HH:mm:ss")}</EsgPrimaryLabel>
            </Box>
            <Box sx={{ gap: 1, display: "flex" }}>
              <PrimaryLabel>Month/Year</PrimaryLabel>
              <EsgPrimaryLabel sx={{ color: "black" }}>{dayjs(detailData?.periodStart).utc().format("MM/YYYY")}</EsgPrimaryLabel>
            </Box>
          </Box>
          <IconButton onClick={() => setOpen(false)}>
            <CloseButton />
          </IconButton>
        </Box>
        <Box sx={{ height: 80, my: "12px" }}>
          <Divider />
          <Box sx={{ m: 3 }}>
            <MaterialReactTable
              enableDensityToggle={false}
              enableTopToolbar={false}
              enableFullScreenToggle={false}
              enableRowSelection={false}
              data={detailData?.approvalSiteDetails || []}
              enablePagination
              columns={DETAIL_MODAL_COLUMNS}
              enableStickyHeader
              enableColumnFilters
              initialState={{ density: "compact" }}
              muiTableContainerProps={{
                sx: {
                  "& thead tr:first-of-type th:first-of-type": {
                    paddingLeft: "20px",
                  },
                  "& tbody tr td:first-of-type": {
                    paddingLeft: "20px",
                  },
                  height: "calc(100vh - 355px)",
                  border: "1px solid #D9D9D9",
                  borderRadius: "10px",
                  minWidth: "100%",
                  width: "100%",
                  maxWidth: "100%",
                  "@media (min-width: 600px)": {
                    width: "100%",
                  },
                  "@media (min-width: 960px)": {
                    width: "1100px",
                  },
                  "@media (min-width: 1280px)": {
                    width: "1100px",
                  },
                  "@media (min-width: 1440px)": {
                    width: "1100px",
                  },
                  "@media (min-width: 1680px)": {
                    width: "1300px",
                  },
                  "@media (min-width: 2400px)": {
                    width: "100%",
                  },
                },
              }}
              muiTablePaperProps={{
                sx: {
                  borderRadius: "10px",
                  boxShadow: "none",
                },
              }}
              muiTopToolbarProps={{
                sx: {
                  backgroundColor: "white",
                  "& .MuiIconButton-root": {
                    display: "none",
                  },
                },
              }}
              muiBottomToolbarProps={{
                sx: {
                  display: "none",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  color: COLORS.Romance,
                  lineHeight: "30px",
                  "& .MuiBadge-root": {
                    display: "none",
                  },
                },
              }}
              muiTableHeadRowProps={{
                sx: {
                  "& > th": {
                    paddingTop: 1,
                    paddingBottom: 1,
                  },
                  height: "45px",
                  backgroundColor: "#F8FAFC",
                  color: COLORS.Romance
                },
              }}
              muiTableBodyRowProps={{
                sx: {
                  cursor: "pointer",
                  backgroundColor: "white",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  </Box>
);
